import { render, staticRenderFns } from "./alert.template.vue?vue&type=template&id=6a76a85a&scoped=true&"
var script = {}
import style0 from "./alert.template.vue?vue&type=style&index=0&id=6a76a85a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76a85a",
  null
  
)

export default component.exports